import { Component, ElementRef, OnInit } from "@angular/core";
import { SharedAnimations } from "src/app/shared/animations/shared-animations";
import { SessionService } from "src/app/store/session/session.service";
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { OpenService } from "@app-services/open.service";
import { LayoutVars } from "@app/store/session/session.store";
import { MarketPlacePersonalizationUtils } from "@app-components/layouts/shopkeeper-layout/marketplace-personalization";
import { CheckUserOptinResponse } from "@app-model/login";
import { PluginRaioXTermsComponent } from "@app-components/layouts/plugin-raio-x-layout/plugin-raio-x-terms.component";
import { MatDialog } from "@angular/material/dialog";
import { DealerService } from "@app-services/dealer.service";
import { AmplifyService } from "@app-services/amplify.service";
import { cpfMask } from "@app-utils/masks";
import { StringUtils } from "@app-utils/StringUtils";

@Component({
  selector: "app-login-ad-auth",
  templateUrl: "./login-ad-auth.component.html",
  styleUrls: ["./login-ad-auth.component.scss"],
  animations: [SharedAnimations]
})
export class LoginADAuthCallbackComponent implements OnInit {
  statusUser: string = null;
  showError = false;
  messageError = "";
  loading: boolean;
  loadingText: string;
  env: string;
  layoutVars: LayoutVars;
  layoutVarsResponse: boolean;

  textError = "";
  returnUrl: string;
  optinResponse: CheckUserOptinResponse;

  acceptedDealerInfo = false;
  acceptedDealerTerms = false;
  acceptedTerms = false;

  savingOptin = false;

  authError = false;
  authErrorMsg: string;
  appClientId: string;
  email: string;
  name: string;
  cpf: string;

  cpfMask = {
    mask: cpfMask
  };


  constructor(
    private openService: OpenService,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private dialog: MatDialog,
    private dealerService: DealerService,
    private amplifyService: AmplifyService
  ) {

    this.env = environment.urlBlog;

  }

  ngOnInit() {
    this.loading = true;

    this.openService.getLayoutVars()
      .subscribe(result => {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, result);
        this.layoutVars = result;
        this.layoutVarsResponse = true;
        if (this.layoutVars && this.layoutVars.logoDestinationUrl) {
          this.env = this.layoutVars.logoDestinationUrl;
        }

        if (this.layoutVars && this.layoutVars.federatedLoginConfigs) {
          let config = this.layoutVars.federatedLoginConfigs[0];

          this.appClientId = localStorage.getItem("federatedAppClientId");
          if (this.appClientId) {
            const filteredConfigs = this.layoutVars.federatedLoginConfigs.filter(c => c.appClientIdAD === this.appClientId);
            if (filteredConfigs && filteredConfigs.length > 0) {
              config = filteredConfigs[0];
            }
          }

          this.amplifyService.configureFederatedLogin(config.appClientIdAD, config.cognitoDomainAD);
        }
        this.amplifyService.isAuthenticated().subscribe(authResp => {

          if (authResp) {
            this.sessionService.checkDealerOptin()
              .subscribe(resp => {
                this.optinResponse = resp;
                if (resp.success) {
                  this.router.navigate(['arrematar', 'maquinas']);
                }
                this.loading = false;
              });

          } else {
            this.loading = false;
            this.authError = true;
            this.authErrorMsg = this.route.snapshot.queryParams["error_description"];
          }

        });

      });


  }


  openTermsConditionsModal(): void {
    this.dialog
      .open(PluginRaioXTermsComponent, {
        width: '480px',
        hasBackdrop: true,
      })
      .afterClosed()
      .subscribe(() => {

      });
  }


  isFormValid(): boolean {
    return this.acceptedDealerInfo && this.acceptedTerms
      && (!this.layoutVars || this.acceptedDealerTerms || !this.layoutVars.personalizedTermsCTA || !this.layoutVars.personalizedTermsUrl);
  }

  submitOptinAccepted(): void {
    this.savingOptin = true;

    if (this.optinResponse.success || this.optinResponse.errorCode === 'MISSING_OPTIN') {
      this.dealerService.acceptOptin(this.appClientId)
        .subscribe(resp => {
          this.savingOptin = false;

          if (resp.success) {
            this.router.navigate(['arrematar', 'maquinas']);
          }
        })

    } else if (this.optinResponse.errorCode === 'INCOMPLETE_INFO' && this.optinResponse.missingFields) {

      const missingEmail = this.isMissingField('EMAIL');
      const missingName = this.isMissingField('NAME');;
      const missingCpf = this.isMissingField('CPF');

      this.sessionService.addDealerUserWithOptin(
        this.appClientId,
        missingEmail ? this.email : undefined,
        missingName ? this.name : undefined,
        missingCpf ? parseInt(StringUtils.onlyNumbers(this.cpf)) : undefined)
        .subscribe(resp => {
          this.savingOptin = false;

          if (resp.success) {
            this.router.navigate(['arrematar', 'maquinas']);
          }
        })
    }
  }

  isMissingField(field: string): boolean {
    if (this.optinResponse.errorCode === 'INCOMPLETE_INFO' && this.optinResponse.missingFields) {
      return this.optinResponse.missingFields.findIndex(m => m === field) >= 0
    } else {
      return false;
    }
  }

}
